import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 352.8 352.8" width="1em" height="1em" {...props}>
    <path
      d="M327.047 176.389a150.658 150.658 0 0 1-150.658 150.658A150.658 150.658 0 0 1 25.73 176.389 150.658 150.658 0 0 1 176.39 25.73 150.658 150.658 0 0 1 327.047 176.39z"
      fill="none"
      stroke="#000"
      strokeWidth={17.639}
      strokeLinecap="round"
    />
    <path
      d="M176.389 119.333v-23.12M176.389 257.311V142.454"
      fill="none"
      stroke="#000"
      strokeWidth={22.931}
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/i.svg